import styles from "../styles/Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.column}>
          <h2 className={styles.logo}>
            Kitchen<span>Bar</span>
          </h2>

          <p>
            A modern destination for handcrafted cocktails, exceptional food,
            and unforgettable nights.
          </p>
        </div>

        <div className={styles.column}>
          <h3>Navigation</h3>

          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#menu">Menu</a>
          <a href="#gallery">Gallery</a>
          <a href="#contact">Contact</a>
        </div>

        <div className={styles.column}>
          <h3>Contact</h3>

          <p>📍 Your City, Cyprus</p>
          <p>📞 +357 XX XXX XXX</p>
          <p>✉ info@kitchenbar.com</p>
        </div>

        <div className={styles.column}>
          <h3>Opening Hours</h3>

          <p>Mon - Thu</p>
          <span>17:00 - 00:00</span>

          <p>Fri - Sat</p>
          <span>17:00 - 02:00</span>

          <p>Sunday</p>
          <span>17:00 - 23:00</span>
        </div>
      </div>

      <div className={styles.bottom}>
        © {new Date().getFullYear()} KitchenBar. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;